import React from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterIcon from "../SVGComponents/FilterIcon";

interface SearchBoxProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onFilterClick?: () => void;
  width?: string | number;
}

export default function SearchBox({
  value,
  onChange,
  placeholder = "Search...",
  onFilterClick,
  width = 350,
}: SearchBoxProps) {
  return (
    <TextField
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      variant="outlined"
      size="small"
      sx={{ 
        width: width,
        '& .MuiOutlinedInput-root': {
          borderRadius: '10px',
          color: 'var(--text)',
          '& fieldset': {
            borderColor: 'var(--border-soft)',
          },
          '&:hover fieldset': {
            borderColor: 'var(--border)',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'var(--border)',
            borderWidth: '1px',
          },
        }
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: '#94a3b8' }} />
            </InputAdornment>
          ),
          endAdornment: onFilterClick ? (
            <InputAdornment position="end">
              <IconButton onClick={onFilterClick} size="small">
                <FilterIcon />
              </IconButton>
            </InputAdornment>
          ) : undefined,
        }
      }}
    />
  );
}
